import { motion } from 'framer-motion'
import { useCampaign } from '../../context/CampaignContext'
import StatsBar from './StatsBar'

const VB_W = 420
const VB_H = 210

// Path: Zigzag going from bottom-right to top-left
// Right-to-Left visually means starting at large X and going to small X
const ARROW_PATH = `M 380,160 L 250,80 L 150,110 L 40,40`

const TIP_X = 40
const TIP_Y = 40
const BARB_LEN = 20

// Tip vector: 150,110 to 40,40 -> dx=-110, dy=-70 -> angle=212 deg from origin (or -148 deg)
// We want barbs pointing back towards 150,110. The opposite vector is +110, +70 -> angle=32 deg
const BARB1_X = TIP_X + Math.round(BARB_LEN * Math.cos((32 + 35) * Math.PI / 180))
const BARB1_Y = TIP_Y + Math.round(BARB_LEN * Math.sin((32 + 35) * Math.PI / 180))
const BARB2_X = TIP_X + Math.round(BARB_LEN * Math.cos((32 - 35) * Math.PI / 180))
const BARB2_Y = TIP_Y + Math.round(BARB_LEN * Math.sin((32 - 35) * Math.PI / 180))

const DOT_X = 380
const DOT_Y = 160

const ProgressBar = () => {
  const { stats } = useCampaign()
  const { total_raised, goal } = stats

  const parsedRaised = Number(String(total_raised).replace(/[^0-9.-]/g, '')) || 0
  const parsedGoal = Number(String(goal).replace(/[^0-9.-]/g, '')) || 0

  const percent = parsedGoal > 0 ? Math.min(parsedRaised / parsedGoal, 1) : 0
  
  // Enforce a minimum visible percentage so the blue line isn't hidden under the red dot
  // The red dot has a radius of 10px, the total path is ~386px long.
  // 6% gives ~23px of path, which sticks out visibly from the dot.
  const visualPercent = parsedRaised > 0 ? Math.max(percent, 0.06) : 0

  return (
    <div className="w-full flex flex-col items-center select-none" dir="rtl">
      <p
        className="text-xl font-bold text-[#1a6fad] font-[FbAsli]"
      >
        הסכום שהושג
      </p>

      <div className="w-full sm:max-w-sm relative">
        <svg viewBox={`0 0 ${VB_W} ${VB_H}`} className="w-full overflow-visible" fill="none">
          {/* Track */}
          <path d={ARROW_PATH} stroke="#e5e7eb" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" fill="none" />

          {/* Progress fill (blue) */}
          <motion.path
            d={ARROW_PATH}
            stroke="#1a6fad"
            strokeWidth="12"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: visualPercent }}
            transition={{ duration: 1.4, ease: 'easeOut' }}
          />

          {/* Arrowhead barbs */}
          <line
            x1={TIP_X} y1={TIP_Y} x2={BARB1_X} y2={BARB1_Y}
            stroke="#e5e7eb" strokeWidth="12" strokeLinecap="round"
          />
          <line
            x1={TIP_X} y1={TIP_Y} x2={BARB2_X} y2={BARB2_Y}
            stroke="#e5e7eb" strokeWidth="12" strokeLinecap="round"
          />

          {/* Red dot at start */}
          <motion.circle
            cx={DOT_X}
            cy={DOT_Y}
            r="10"
            fill="#e62e2e"
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 1] }}
            transition={{ delay: 0.4, duration: 0.5, ease: 'easeOut' }}
          />
        </svg>

        {/* Stats placed absolutely to center under the line graph */}
        <div className="md:absolute md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-[-50px]">
          <StatsBar />
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
